module.exports = __webpack_public_path__ + "static/media/IIT_Kharagpur_Logo.13e4769a.jpeg";